import React from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { FormControlLabel as MuiFormControlLabel, Checkbox as MuiCheckbox } from '@mui/material'
import { darkTheme, lightTheme } from '../theme'
import { CircleOutlined, CheckCircle } from '@mui/icons-material'

export default function Checkbox(props) {
  const { checked, onChange, disabled, value, sx, label = '', ...other } = props

  const darkMode = useMediaQuery('(prefers-color-scheme: dark)', { noSsr: true })
  const theme = darkMode ? createTheme(darkTheme()) : createTheme(lightTheme())

  return (
    <ThemeProvider theme={theme}>
      <MuiFormControlLabel
        value={value}
        label={label}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        sx={{ alignItems: 'flex-start', mt: 1, mb: 1, ...sx }}
        {...other}
        control={
          <MuiCheckbox
            disableRipple
            icon={<CircleOutlined />}
            checkedIcon={<CheckCircle />}
            sx={{
              mt: -1,
              '&.Mui-checked': {
                color: '#0072DE'
              }
            }}
          />
        }
      />
    </ThemeProvider>
  )
}
